module.exports = __webpack_public_path__ + "img/parcel-in.7533ea4d.svg";